import { call, put } from 'redux-saga/effects';
import api from '@/services/api';
import Toast from '@/utils/toast';
import MessageActions from '@/store/ducks/message';
import { GLOBAL_CONSTANTS } from '@/utils/globalConstants';
import { checkEmpty } from '@/utils/commonFunctions';

export function* sendMessageRequest(action) {
  try {
    const {
      API_URLS: { sendMail },
    } = GLOBAL_CONSTANTS;
    const { data } = yield call(api.post, sendMail, { mail: action.payload });
    yield put(MessageActions.sendMessageSuccess(data?.data));
    if (!checkEmpty(data) && data?.status) {
      Toast.success('Message sent successfully!');
    }
  } catch (error) {
    if (error?.response) {
      const errorResponse = { ...(error?.response?.data || {}), data: { timestamp: Date.now() } };
      yield put(MessageActions.sendMessageFailure(errorResponse));
    }
    Toast.error('Message sent failed!');
  }
}
